import { Link } from "react-router-dom";
import PlatformSolutonComponent from "../../common/PlatformSolutionComponent";
import { useParams } from 'react-router';
import { useState } from "react";

const Platform = () => {
  const { id } = useParams();

  const subRoutesNames = {
    domestic: 'Domestic',
    international: 'International',
    supply: 'Supply Chain Solutions',
    value: 'Value Added Services'
  };

  const getRoute = subRoutesNames[`${id}`];
  var [state, setState] = useState(getRoute);

  const updatePage = title => {
    setState(title);
  }
  
  
  return (
    <div>
      {state === "Domestic" && <img src="/domestic.jpg" alt="" className="w-full" ></img>}
      {state === "International" && <img src="/International.jpg" alt="" className="w-full"></img>}
      {state === "Supply Chain Solutions" && <img src="/supply-chain-solutions.jpg" alt="" className="w-full"></img>}
      {state === "Value Added Services" && <img src="/value-added-services.jpg" alt="" className="w-full"></img>}
      <PlatformSolutonComponent value={{data: id, updatePage}} ></PlatformSolutonComponent>
    </div>

  );
};

export default Platform;
